import type { Product, Category } from "./types";

export const CATEGORIES: Category[] = [
  {
    slug: "ingles-general",
    name: "Inglés general",
    description: "Cursos y guías completas para avanzar en tu inglés.",
  },
  {
    slug: "gramatica",
    name: "Gramática",
    description: "Reglas explicadas con claridad y ejercicios prácticos.",
  },
  {
    slug: "vocabulario",
    name: "Vocabulario",
    description: "Amplía tu léxico con listas temáticas y contexto real.",
  },
  {
    slug: "reading",
    name: "Reading",
    description: "Textos graduados y estrategias de comprensión.",
  },
  { slug: "writing", name: "Writing", description: "Modelos, plantillas y práctica de escritura." },
  {
    slug: "listening",
    name: "Listening",
    description: "Audios y transcripciones para entrenar el oído.",
  },
  {
    slug: "speaking",
    name: "Speaking",
    description: "Frases, guiones y práctica de conversación.",
  },
  {
    slug: "pronunciacion",
    name: "Pronunciación",
    description: "Fonética clara, sin tecnicismos innecesarios.",
  },
  {
    slug: "ingles-profesional",
    name: "Inglés profesional",
    description: "Correos, reuniones, entrevistas y presentaciones.",
  },
  {
    slug: "examenes",
    name: "Preparación para exámenes",
    description: "Estrategia y práctica para exámenes oficiales.",
  },
];

export const FEATURED_CATEGORY_SLUGS = [
  "ingles-general",
  "gramatica",
  "vocabulario",
  "reading",
  "writing",
  "listening",
  "speaking",
  "pronunciacion",
  "ingles-profesional",
  "examenes",
];

export function getProductCategories(product: Product): string[] {
  const categories = product.categories?.filter(Boolean) ?? [];
  return Array.from(new Set(categories.length > 0 ? categories : [product.category]));
}

/** Categorías que realmente tienen productos publicados. */
export function categoriesWithProducts(products: Product[]): Category[] {
  const active = new Set(products.flatMap(getProductCategories));
  return CATEGORIES.filter((c) => active.has(c.slug));
}

export function getProductBySlugOrId(products: Product[], idOrSlug: string): Product | undefined {
  return products.find((p) => p.id === idOrSlug || p.slug === idOrSlug);
}
